import React from 'react';
import classNames from 'classnames';

import styles from './ProgressBar.module.scss';

interface ProgressBarProps {
  value?: number;
  className?: string | null;
  fillerClassName?: string | null;
}

const ProgressBar = ({
  value = 0,
  className = null,
  fillerClassName = null,
}: ProgressBarProps) => (
  <div
    className={classNames(styles.progressBar, className)}
    data-testid="progress-bar"
  >
    <div
      className={classNames(styles.filler, 'h-100', fillerClassName)}
      style={{ width: `${Math.max(0, Math.min(1, value)) * 100}%` }}
    />
  </div>
);

export default React.memo(ProgressBar);
